<template>
    <div class="form-wrap">
        <div class="form-item">
            <div class="item-title">发布BU：</div>
            <div class="item-text">{{ data.pub_bu_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">接收BU：</div>
            <div class="item-text">{{ data.sub_bu_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">任务类型：</div>
            <div class="item-text">{{ data.tpl_name }}</div>
        </div>
        <!-- <div class="form-item">
            <div class="item-title">类型说明：</div>
            <div class="item-text"><div>{{ tempTask.tpl_description }}</div></div>
        </div> -->
        <div class="form-item">
            <div class="item-title">任务名称：</div>
            <div class="item-text">{{ data.task_name }}</div>
        </div>
        <div class="form-item" v-show="data.task_description">
            <div class="item-title">任务描述：</div>
            <div class="item-text">{{ data.task_description }}</div>
        </div>
        <div class="form-item" v-show="data.status!=1">
            <div class="item-title">审核说明：</div>
            <div class="item-text">{{ data.fail_result }}</div>
        </div>

        <!-- <sliderHistoty :data="data.req"></sliderHistoty> -->

        <!-- 审核 -->
        <div v-if="data.process_status==102 && $route.name!='my-application'"  v-form:apply-release>
            <div class="form-line" text="审核处理"></div>

            <div class="form-item">
                <div class="item-title">审核说明：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="'审核说明'" v-tar="examine.result" v-model="examine.result" placeholder="请输入审核说明"></textarea>
                </div>
            </div>

            <div class="form-footer">
                <el-button type="primary" @click="checkPass">通 过</el-button>
                <el-button type="primary" @click="checkNotPass">不通过</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    // import sliderHistoty from "src/components/slider/slider_history.vue"
    import { getAllTemp } from 'src/control/common.js';  //公共方法
    import { mapGetters,mapState } from "vuex"

    export default {
        props:["sliderArg","data","resub","examine"],
        components:{
            // sliderHistoty,
        },
        data(){
            return {

            }
        },

        computed:{
            ...mapState(["apply"]),
            // tempTask(){  //详情任务的任务模板
			// 	let tempId = this.data.template_id;
			// 	return  tempId?getAllTemp(tempId):{};
			// },
        },

        watch:{
            data(val){
                let count = 0;
                for(let i in val){
                    count++;
                };
                if(count == 0){
                    this.$form.clear("budget-again");
                    this.$form.clear("apply-release");
                }
            },
        },

        methods:{
            checkPass(){
                let res = this.$form.check("apply-release");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 0;
				this.sliderArg.insideFlag = true;
            },
            checkNotPass(){
                let res = this.$form.check("apply-release");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 1;
				this.sliderArg.insideFlag = true;
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/slider.less";
</style>





// WEBPACK FOOTER //
// slider_releaseTask.vue?02e7a3e8